import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargingCardOutboundInfoComponent } from './info.component';
import { SlideCardModule } from '../../../../component-lib/components/slide-card/slide-card.module';
import { TranslateModule } from '@ngx-translate/core';
import ButtonModule from '../../../../component-lib/components/button/button-module';
import { ModalModule } from '../../../../component-lib/components/modal/modal.module';

@NgModule({
  declarations: [ChargingCardOutboundInfoComponent],
  imports: [CommonModule, SlideCardModule, ButtonModule, TranslateModule, ModalModule],
  exports: [ChargingCardOutboundInfoComponent],
})
export class ChargingCardOutboundInfoModule {}
